<template>
  <div class="example_content-components">
    <div class="example_content">
      <div class="title">
        <p v-html="title">
        </p>
      </div>
      <div class="message">
        <p>
          {{message}}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExampleContent',
  props: {
    title: String,
    message: String,
  }
}
</script>
<style scoped lang="scss">
.example_content {
  margin: 0 auto;
  font-size: 12px;
  display: flex;
  max-width: 750px;
  width: 100%;
  margin-bottom: 5px;
}
.title {
  width: 215px;
  background-color: #ffce48;
  margin-right: 5px;
  line-height: 2em;
  p {
    padding: 1em 2em;
  }
}
.message {
  max-width: 530px;
  width: 100%;
  background-color: #ddd;
  line-height: 2em;
  p {
    padding: 1em 2em;
  }
}
</style>
